import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import type { TaskLabwareCorrespondence } from '../../../types';
import CustomWidthTooltip from '../../CustomWidthTooltip';

const CircleBackdrop = styled(Box)`
  position: relative;
  display: inline-block;
  border-radius: 50%;
  line-height: 0;
  background-color: ${(p) => p.theme.palette.grey['100']};
  transform: translateY(calc(50% + 4px));
`;

type TimeConstraintClockIconProps = {
  labwareCorrespondence: TaskLabwareCorrespondence;
};

export const getTimeConstraintSuggestionCopy = ({
  labwareCorrespondence,
}: TimeConstraintClockIconProps): string | null => {
  if (labwareCorrespondence === 'NO_LABWARE_ASSIGNED') {
    return 'Assign labware to tasks for this time constraint to be applied.';
  }
  return null;
};

const TimeConstraintClockIcon = ({
  labwareCorrespondence,
}: TimeConstraintClockIconProps): JSX.Element => {
  const inner = (
    <CircleBackdrop>
      <AccessTimeIcon fontSize="large" />
    </CircleBackdrop>
  );

  const tooltipCopy = getTimeConstraintSuggestionCopy({
    labwareCorrespondence,
  });

  if (tooltipCopy === null) {
    return inner;
  }

  return (
    <CustomWidthTooltip
      title={
        <Box pl={3}>
          <Typography
            variant="h6"
            component="h2"
            sx={{ textTransform: 'uppercase' }}
          >
            Incomplete time constraint:
          </Typography>
          <List sx={{ listStyleType: 'disc' }}>
            <ListItem sx={{ display: 'list-item' }}>
              <Typography variant="subtitle2" component="p">
                {tooltipCopy}
              </Typography>
            </ListItem>
          </List>
        </Box>
      }
      placement="right"
    >
      {inner}
    </CustomWidthTooltip>
  );
};

export default TimeConstraintClockIcon;
